import React, { Component } from 'react';
import ProductBasketListing from './ProductBasketListing';

class BasketProducts extends Component {    
    render() {
        return (
//rebuild
            <ProductBasketListing />
        )
    }
}
export default BasketProducts;